import { debugValidateProps } from "../util/generic";

export class CharStats {
    object: any;
    attackSpeedBase: number | undefined;
    attackSpeed: number | undefined;

    constructor(charObj: any) {
        this.object = charObj;

        this.attackSpeedBase = undefined;
        this.attackSpeed = undefined;
    }

    debugValidate() {
        debugValidateProps(this, [
            ["attackSpeedBase", 1, 999999],
            ["attackSpeed", 1, 999999],
        ]);
    }

    _getEquipData(equipIdx: any) {
        const itemData = GDM.getNow("item_data");
        const equipItemType = ITMPARTTOTYPE[equipIdx];
        const visPartIdx = ITMPARTTOVISPART[equipIdx];
        const item = this.object.visParts[visPartIdx];
        if (item.itemType === 0) {
            // Empty Slot
            return null;
        }
        return itemData.getData(equipItemType, item.itemNo);
    }

    getAttackSpeed() {
        // Spawn packets carry the server's percentage directly (88 is 88%).
        return this.attackSpeed || 100;
    }

    getAttackDistance() {
        const weaponData = this._getEquipData(INVEQUIPIDX.WEAPON);
        if (!weaponData) {
            return global.DEFAULT_ATTACK_DISTANCE;
        }
        return weaponData[WEAPON_DATA.RANGE] / 100;
    }

    getMoveSpeed() {
        return 535 + this.object.stats.dex;
    }

    getCritical() {
        // TODO: Implement proper critical calculation
        return 10; // Stub
    }

    getDefense() {
        // Basic defense: con + equipment defense
        let defense = this.object.stats.con;
        // Add defense from armor pieces
        const armorSlots = [
            INVEQUIPIDX.HELMET,
            INVEQUIPIDX.ARMOR,
            INVEQUIPIDX.GAUNTLET,
            INVEQUIPIDX.BOOTS,
        ];
        for (const slot of armorSlots) {
            const equipData = this._getEquipData(slot);
            if (equipData) {
                defense += equipData[10] || 0; // Assuming defense is at index 10
            }
        }
        return defense;
    }

    getAttackPower() {
        // Basic attack power: str * 2 + level + weapon attack
        let attack = this.object.stats.str * 2 + this.object.level;
        const weaponData = this._getEquipData(INVEQUIPIDX.WEAPON);
        if (weaponData) {
            attack += weaponData[WEAPON_DATA.ATTACK_POWER] || 0;
        }
        return attack;
    }

    getMagicDefense() {
        // TODO: Implement proper magic defense calculation
        return 10; // Stub
    }

    getAccury() {
        // TODO: Implement proper accuracy calculation
        return 30; // Stub
    }

    getDodge() {
        // TODO: Implement proper dodge calculation
        return 30; // Stub
    }

    getMaxWeight() {
        // TODO: Implement proper max weight calculation
        return 1000; // Stub
    }

    getMaxSummonGauge() {
        // TODO: Implement proper max summon gauge calculation
        return 50; // Stub
    }

    getMPReduction() {
        // TODO: Implement proper MP reduction calculation
        return 0; // Stub
    }
}
